import React, { useState, useEffect } from 'react';
import liveAuth from 'src/helper/liveAuth';
import System from 'src/helper/system';
import { useBOMStore } from 'src/hooks/bom';

const BomName = () => {
    const bom_id = System.getParams().bomId;
    const [{ bom_detail_by_bom_id }, { get_bom_detail_by_bom_id }, { edit_bom_name }] = useBOMStore();
    const [isEdit, setIsEdit] = useState(false);
    const [bomName, setBomName] = useState('');
    const [messageShow, setMessageShow] = useState(false);

    useEffect(() => {
        const fetchBomDetail = async () => {
            await get_bom_detail_by_bom_id({ bomId: bom_id });
        };
        bom_id && fetchBomDetail();
    }, [bom_id]);

    useEffect(() => {
        if (bom_detail_by_bom_id === null) {
            window.history.back();
        } else if (bom_detail_by_bom_id) {
            setBomName(bom_detail_by_bom_id.bomName || '');
        }
    }, [bom_detail_by_bom_id]);

    const onSubmitEdit = async () => {
        if (bomName.trim()) {
            const res = await edit_bom_name({ bomId: bom_detail_by_bom_id.bomId, bomName: bomName.trim() });
            if (res) {
                await get_bom_detail_by_bom_id({ bomId: bom_id });
                setIsEdit(false);
                setMessageShow(false);
                //by Ramya Kannan (Rename BOM - Adobe script)
                localStorage.setItem("adobeEventType","renameBom");
            }
        } else {
            setMessageShow(true);
        }
    };

    const onCloseButton = () => {
        setBomName(bom_detail_by_bom_id.bomName || '');
        setIsEdit(false);
        setMessageShow(false);
    };

    return (
        bom_detail_by_bom_id && Object.keys(bom_detail_by_bom_id).length > 0 && (
            !isEdit ? (
                <h4 className="m-0 font-16">
                    <span className="me-2 text-black">{bom_detail_by_bom_id.bomName}</span>
                    {liveAuth.check() && (
                        <a onClick={() => setIsEdit(true)}>
                            <i className="fa fa-pencil font-12"></i>
                        </a>
                    )}
                </h4>
            ) : (
                <div className="edit-bom-header">
                    <div className='d-flex align-items-center'>
                    <div>
                        <input
                            type="text"
                            className={(messageShow && !bomName.trim()) ? "form-control form-control-sm me-1 error" : 'form-control form-control-sm me-1'}
                            placeholder="Enter BOM Name"
                            value={bomName}
                            onChange={(e) => setBomName(e.target.value)}
                        />
                        
                    </div>
                    <div className="d-flex align-items-start">
                        <button className="bs5 btn-link tdn text-blue2" onClick={onCloseButton}>
                            Cancel
                        </button> 
                        |
                        <button className="bs5 btn-link tdn text-blue2" onClick={onSubmitEdit}>
                            Save
                        </button>
                    </div>
                    </div>
                    <div>
                    {(messageShow && !bomName.trim()) && <p className="error mb-0">BOM Name cannot be empty.</p>}
                    </div>
                </div>
            )
        )
    )
};

export default BomName;
